import { useState } from 'react';
import { Delete_All_User } from '../../services/oprations/Users';

export const useBulkOperations = (filteredUsers, dispatch, refreshUsers, toast, setLocalUserOverrides) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [isBulkDeleteOpen, setIsBulkDeleteOpen] = useState(false);
  const [isBulkDeleting, setIsBulkDeleting] = useState(false);
  // eslint-disable-next-line
  const [bulkProgress, setBulkProgress] = useState({ current: 0, total: 0 });

  const allFilteredSelected = filteredUsers.length > 0 && 
    filteredUsers.every(u => selectedIds.includes(u._id));
  const someSelected = selectedIds.length > 0;

  const toggleSelectAll = () => {
    if (allFilteredSelected) {
      setSelectedIds(prev => prev.filter(id => !filteredUsers.some(u => u._id === id)));
    } else {
      setSelectedIds(prev => [...new Set([...prev, ...filteredUsers.map(u => u._id)])]);
    }
  };

  const toggleSelectUser = (e, userId) => {
    e.stopPropagation();
    setSelectedIds(prev => 
      prev.includes(userId) 
        ? prev.filter(id => id !== userId) 
        : [...prev, userId]
    );
  };

  const clearSelection = () => setSelectedIds([]);

  // const handleBulkDeleteConfirm = async () => {
  //   try {
  //     setIsBulkDeleting(true);
  //     const res = await dispatch(Delete_All_User(selectedIds));
  //     if (res?.data?.success) {
  //       toast.success(`Deleted ${selectedIds.length} users successfully`);
  //       await refreshUsers();
  //       clearSelection();
  //       setIsBulkDeleteOpen(false);
  //     }
  //   } catch (error) {
  //     toast.error(error?.response?.data?.message || 'Failed to delete users');
  //   } finally {
  //     setIsBulkDeleting(false);
  //   }
  // };
  const handleBulkDeleteConfirm = async () => {
    const idsToDelete = [...selectedIds];
    try {
      // Optimistically remove immediately
      setLocalUserOverrides(prev => {
        const next = { ...prev };
        idsToDelete.forEach(id => { next[id] = { _deleted: true }; });
        return next;
      });
      setIsBulkDeleteOpen(false);
      clearSelection();

      const res = await dispatch(Delete_All_User(idsToDelete));
      if (res?.data?.success) {
        toast.success(`Deleted ${idsToDelete.length} users successfully`);
        await refreshUsers();
      } else {
        // Rollback on failure
        setLocalUserOverrides(prev => {
          const next = { ...prev };
          idsToDelete.forEach(id => { delete next[id]; });
          return next;
        });
        setIsBulkDeleteOpen(true);
        toast.error('Failed to delete users');
      }
    } catch (error) {
      setLocalUserOverrides(prev => {
        const next = { ...prev };
        idsToDelete.forEach(id => { delete next[id]; });
        return next;
      });
      toast.error(error?.response?.data?.message || 'Failed to delete users');
    } finally {
      setIsBulkDeleting(false);
    }
  };

  return {
    selectedIds,
    setSelectedIds,
    isBulkDeleteOpen,
    setIsBulkDeleteOpen,
    isBulkDeleting,
    bulkProgress,
    toggleSelectAll,
    toggleSelectUser,
    clearSelection,
    handleBulkDeleteConfirm,
    allFilteredSelected,
    someSelected
  };
};
